import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { membership_returndata } from 'src/types/membership_returndata'; 
import { bmxurl, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { BusyService } from '../_services/busy.service';

@Component({
  selector: 'app-membershiptypes',
  templateUrl: './membershiptypes.component.html',
  styleUrls: ['./membershiptypes.component.css']
})

export class MembershiptypesComponent  implements OnInit {
  
  ListMemberships: any;
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  httpResponse: any;
  DisabledMembership: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  showExpired: boolean = false;
  AllMemberships: any[] = [];
  selectedItems: any;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;


  constructor(
    private http: HttpClient, private appComp: AppComponent, private router: Router, private messageService: MessageService, private globalService: GlobalService, private busyService: BusyService) {

    }

  onRowReorder(_event: any) {
    this.busyService.busy();

    // PrimeNG 13 reorders the array in-place before firing this event,
    // so we just assign displayOrder from the already-correct positions.
    this.ListMemberships.data.forEach((membership, index) => {
      membership.displayOrder = index;
    });

    // Guard against ever sending scheduled sessions in a Membership Types reorder payload -
    // each screen must only reorder its own category within the shared membershiptype table.
    const reorderPayload = this.ListMemberships.data
      .filter(m => m.membershiptype != "SCHEDULEDSESSION")
      .map(m => ({
        membershiptypeid: m.membershiptypeid,
        displayorder: m.displayOrder
      }));

    this.http.post(bmxurl + "MembershipTypeReorder", { venueid: this.VenueID, membershiptypes: reorderPayload }).subscribe(() => {
      this.busyService.idle();
    }, error => {
      this.busyService.idle();
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while reordering Membership Types, error:' + error.messages[0]});
    });
  }

  addMembership()
  {
    let canaccessmembershipss = localStorage.getItem("Betamembership");

    if(canaccessmembershipss != "true")
    {
      this.messageService.add({life: 7000, severity:'warn', summary:'Not Allowed', detail:"Our membership system is in beta mode. You're invited to test it and provide feedback at support@smart-entertainment.co.uk. During the beta phase, we charge a standard 2% rate on purchases, but there is no processing fee for membership admissions. You can turn this on by going to settings and setting 'Try Beta Memberships' to 'Yes' in the Beta section"});
      return;
    }
    else
    {
      this.router.navigateByUrl("/membershipedit/0");
    }
  }
  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("CLASSES", user)){
          this.AccessAllowed = true;
          this.loadgrid(false);
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });

  }

  toggleDisabled(){
    this.loadgrid(!this.isDisabled);
  }

  //Expired types cannot be sold any more, so they are hidden by default and would otherwise
  //clutter the setup screen. The toggle brings them back for anyone who needs to find one.
  toggleExpired(showExpired: boolean){
    this.showExpired = showExpired;
    this.applyExpiredFilter();
  }

  applyExpiredFilter(){
    if (this.ListMemberships == null) {
      return;
    }

    if (this.showExpired) {
      this.ListMemberships.data = [...this.AllMemberships];
      return;
    }

    let now = new Date().getTime();

    this.ListMemberships.data = this.AllMemberships.filter((m: any) => new Date(m.enddate).getTime() > now);
  }

  isExpired(membership: any): boolean {
    return membership != null && new Date(membership.enddate).getTime() <= new Date().getTime();
  }

  disableData(MembershipID)
  {
    this.http.delete(bmxurl + "membershiptype/" + this.VenueID + "/" + MembershipID).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded == true)
      {
        this.messageService.add({severity:'success', summary:'Disabled', detail:'Membership successfully disabled'});
        this.router.navigateByUrl("/memberships");

        this.loadgrid(false);
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Membership'});
    })
  }
  
  loadgrid(showdisabled: boolean)
  {
    this.http.get(bmxurl + "membershiptypevenuelist/" + this.VenueID + "/" + showdisabled).subscribe(response => { 
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.ListMemberships = (response as membership_returndata);

        let tempList = [];

        this.ListMemberships.data.forEach(element => {
          if (element.membershiptype != "SCHEDULEDSESSION") {
            //Expired types are kept here and filtered out for display, so the toggle can bring
            //them back without another round trip.
            tempList.push(element);
          }
        });

        this.AllMemberships = tempList.sort((a, b) => (a.displayorder ?? a.displayOrder ?? 0) - (b.displayorder ?? b.displayOrder ?? 0));

        this.applyExpiredFilter();

        if ((response as membership_returndata).messages.length > 0)
        {
          (response as membership_returndata).messages.forEach(error => {
            this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
          });
        }
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Response Message', detail: "Error getting Memberships, error:" + this.httpResponse.messages[0]});

        // this.ListMemberships = (response as membership_returndata);

        // let tempList = [];

        // this.ListMemberships.data.forEach(element => {
        //   if (element.membershiptype != "SCHEDULEDSESSION") {
        //     if(new Date(element.enddate).getTime() > new Date().getTime())
        //       tempList.push(element);
        //   }
        // });

        // this.ListMemberships.data = tempList;
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Memberships, error: ' + error.messages});
    });
  }

  editData(EditData)
  {
    let MembershipID = EditData;
    this.router.navigateByUrl("/membershipedit/" + MembershipID);
  }

  disableMulti()
  {
    this.selectedItems.forEach(element => {

    this.http.delete(bmxurl + "membershiptype/" + this.VenueID + "/" + element.membershipid).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.loadgrid(false);
      } 
      else{
        this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error disabling Memberships, error: ' + this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error disabling Memberships, error: ' + error.messages});
    })
    });
    
  }

  
  }
